// Navigation targets for the labs suite.
//
// - NERDLE_HOME: the main nerdle site (the top-bar logo + home icon both link here).
// - labsHomeUrl(): the labs landing (/labs) — parent of the current game path (/labs/rebus -> /labs).
//   Used by "Back to other games" so a player can switch games / see the game picker.
// - labsGameUrl(slug): a sibling game (/labs/<slug>), for direct cross-game seeding buttons.

export const NERDLE_HOME = 'https://www.nerdlegame.com'

export const labsHomeUrl = (): string => {
  if (typeof window === 'undefined') return '/labs'
  const path = window.location.pathname.replace(/\/+$/, '')
  const parent = path.replace(/\/[^/]*$/, '')
  return parent || '/labs'
}

export const labsGameUrl = (slug: string): string => `${labsHomeUrl()}/${slug}`
